import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
    fetchGeotreesApi,
    filterGeoTreeApi,
    fetchGoeTreeByIdApi,
    getJobFunctionApi,
    updateGeoTreeApi,
    addGeoTreeApi,
    getemployeesApi,
    fetchPositionsApi,
} from "../../../api/endpoint";

function* getGeotreesSaga(action) {
    try {
        const _api = yield call(fetchGeotreesApi, action.payload);
        yield put(actions.setGeotrees(_api.data.results));
        yield put(commonActions.setLoading(false));
    } catch (error) {
        console.log(error);
        yield put(commonActions.setLoading(false));
    }
}

function* filterGeoTreeSaga(action) {
    try {
        const _api = yield call(filterGeoTreeApi, action.payload);
        if (_api?.data?.success) {
            yield put(actions.setGeoTreeFilteredResults(_api.data.results));
            yield put(commonActions.setClearFilter(true));
        }
    } catch (error) {
        console.log(error);
    }
}

function* getGeoTreeByIdSaga(action) {
    try {
        const _api = yield call(fetchGoeTreeByIdApi, action.payload);
        yield put(actions.setGeoTreeById(_api.data.results));
        yield put(commonActions.setLoading(false));
    } catch (error) {
        console.log(error);
        yield put(commonActions.setLoading(false));
    }
}

function* jobFunctionFilterDataSaga(action) {
    try {
        const _api = yield call(getJobFunctionApi, action.payload);
        yield put(actions.setJobFunctionFilterData(_api.data.results));
        yield put(commonActions.setLoading(false));
    } catch (error) {
        console.log(error);
        yield put(commonActions.setLoading(false));
    }
}

function* getJobFunctionsSaga(action) {
    try {
        const _api = yield call(getJobFunctionApi, action.payload);
        yield put(actions.setJobFunction(_api.data.results));
        yield put(commonActions.setLoading(false));
    } catch (error) {
        console.log(error);
        yield put(commonActions.setLoading(false));
    }
}

function* updateGeotreeSaga(action) {
    try {
        const _api = yield call(updateGeoTreeApi, action.payload);
        if (_api?.data?.success) {
            // yield put(actions.setUpdateGeoTree(action.payload));
            yield put(commonActions.setLoading(false));
            yield put(commonActions.setRedirect(true));
        }
    } catch (error) {
        console.log(error);
        yield put(commonActions.setLoading(false));
    }
}

function* getEmployeeSaga(action) {
    try {
        const _api = yield call(getemployeesApi, action.payload);
        yield put(actions.setEmployees(_api.data.results?.employees));
        yield put(commonActions.setLoading(false));
    } catch (error) {
        console.log(error);
        yield put(commonActions.setLoading(false));
    }
}

function* getPositionsSaga(action) {
    try {
        const _api = yield call(fetchPositionsApi, action.payload);
        yield put(actions.setPositions(_api.data.results?.Positions));
        yield put(commonActions.setLoading(false));
    } catch (error) {
        console.log(error);
        yield put(commonActions.setLoading(false));
    }
}

function* addGeoTreeSaga(action) {
    try {
        const _api = yield call(addGeoTreeApi, action.payload);
        if (_api?.data?.success) {
            yield put(commonActions.setLoading(false));
            yield put(commonActions.setRedirect(true));
        }
        else {
            console.log("Error in addGeoTreeSaga: ");
        }
    } catch (error) {
        console.log(error);
        if (error.message === "Request failed with status code 422") {
            yield put(commonActions.setError(true));
            yield put(commonActions.setErrorMessage("The GeoTree code already exists"));
            yield put(commonActions.setLoading(false));
        }
    }
}

export function* watchGeotreesSaga() {
    yield all([
        takeEvery(actionTypes.GET_GEOTREES, getGeotreesSaga),
        takeEvery(actionTypes.GET_GEOTREE_FILTERED_RESULTS, filterGeoTreeSaga),
        takeEvery(actionTypes.GET_GEOTREE_BY_ID, getGeoTreeByIdSaga),
        takeEvery(
            actionTypes.GET_JOB_FUNCTION_FILTER_DATA,
            jobFunctionFilterDataSaga
        ),
        takeEvery(actionTypes.GET_JOB_FUNCTION, getJobFunctionsSaga),
        takeEvery(actionTypes.UPDATE_GEOTREE, updateGeotreeSaga),
        takeEvery(actionTypes.ADD_GEO_TREE, addGeoTreeSaga),
        takeEvery(actionTypes.GET_EMPLOYEES, getEmployeeSaga),
        takeEvery(actionTypes.GET_POSITIONS, getPositionsSaga),
    ]);
}
